import { ScopeType } from '@percent/partner-dashboard/context/auth/authContext/AuthContext.types'

export const selectScopes = (scopes?: ScopeType[]) =>
  scopes
    ?.filter(scope => !scope.deletedAt)
    .reduce(
      (obj, { scopeName }) => ({
        ...obj,
        [scopeName]: true as const
      }),
      {} as { [k: string]: true }
    ) || {}
